/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:08:38
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-19 14:55:03
 */
import req from "@/utils/request";

//  get 请求示列
export const countUserData = (params) => req.post("/dataCenter-service/m/user/countUserData", params);
export const list = (params) => req.post("/site-service/m/site/list", params);

